import { useEffect, useRef } from 'react';

import { channelManager } from './channel-manager';
import { SizeInfoChannelMessage } from './types';

export { SIZE_INFO_CHANNEL, SizeInfoAction } from './constants';
export type {
  AgreementType,
  DirectInputItem,
  DirectInputMeasurements,
  SizeInfoActionType,
  SizeInfoChannelMessage,
  SizeInfoPayloadMap,
} from './types';
export { isSizeInfoChannelMessage } from './validators';

export const sendSizeInfoMessage = (message: SizeInfoChannelMessage) => {
  channelManager.send(message);
};

export const useSizeInfoChannelListener = (onMessage: (message: SizeInfoChannelMessage) => void) => {
  const savedHandler = useRef(onMessage);

  useEffect(() => {
    savedHandler.current = onMessage;
  }, [onMessage]);

  useEffect(() => {
    // 컴포넌트 마운트 시 구독, 언마운트 시 자동 구독 해제
    const unsubscribe = channelManager.subscribe((message) => {
      savedHandler.current(message);
    });
    return unsubscribe;
  }, []);
};
